export default "__VITE_PUBLIC_ASSET__ac407813__"